const RESOURCE_NAME = '/msgs';

export default axios => ({
    getGroupBy4Date(unitId, date, groupBy, params, config = {}) {
        let url = `${RESOURCE_NAME}/${date}/group-by/${groupBy}`
        /*if (unitId > '')*/ url = `/unit/${unitId}`+url
        return axios.get(url, {params, ...config});
    },
    getGroupBy4Period(unitId, from, to, groupBy, params) {
        let url = `${RESOURCE_NAME}/${from}/${to}/group-by/${groupBy}`
        /*if (unitId > '')*/ url = `/unit/${unitId}`+url
        return axios.get(url, {params});
    },
});